import { CustomersArray } from '../types/Customer';
import { client } from './Client';

export const getCustomers = async (): Promise<CustomersArray> =>
    client.get('/customers').then((response) => response.data);
